export default {
  'clientInfo.add': 'Thêm biểu ngữ',
  'clientInfo.bannerTitle': 'Tiêu đề',
  'clientInfo.enterBannerTitle': 'Vui lòng nhập tiêu đề',
  'clientInfo.bannerTitleMaxLength': 'Độ dài tiêu đề không được vượt quá 50 ký tự',
  'clientInfo.displayTarget': 'Nhóm người dùng hiển thị',
  'clientInfo.allUsers': 'Tất cả người dùng',
  'clientInfo.allUsersOneClick': 'Tất cả người dùng',
  'clientInfo.advancedSettings': 'Cài đặt nâng cao (Tùy chọn)',
  'clientInfo.liveStreamTag': 'Live Stream',
  'clientInfo.unloggedUser': 'Người dùng chưa đăng nhập (Khách)',
  'clientInfo.noDepositUser': 'Người dùng chưa nạp tiền',
  'clientInfo.noDepositUserTip': 'Người dùng chưa nạp tiền chỉ áp dụng cho người chơi đã đăng nhập và chưa nạp lần đầu, không thể chọn cùng Cấp VIP hoặc Người dùng chưa đăng nhập',
  'clientInfo.vipLevelGroup': 'Cấp VIP',
  'clientInfo.client': 'Khách hàng',
  'clientInfo.langName': 'Ngôn ngữ',
  'clientInfo.forwardCode': 'Mã chuyển tiếp',
  'clientInfo.indexSpopupType': 'Loại cửa sổ bật lên của trang chủ',
  'clientInfo.currency': 'Tiền tệ',
  'clientInfo.selectCurrency': 'Vui lòng chọn tiền tệ',
  'clientInfo.imageType': 'Vị trí hiển thị',
  'clientInfo.selectImageType': 'Vui lòng chọn vị trí hiển thị',
  'clientInfo.selectDisplayTarget': 'Vui lòng chọn đối tượng hiển thị',
  'clientInfo.liveUrl': 'Địa chỉ Live Stream',
  'clientInfo.enterLiveUrl': 'Vui lòng nhập địa chỉ live stream',
  'clientInfo.liveUrlMaxLength': 'Địa chỉ live stream không được vượt quá 500 ký tự',
  'clientInfo.liveColumn': 'Live',
  'clientInfo.selectLiveFilter': 'Vui lòng chọn',
  'clientInfo.hasLiveUrl': 'Có Live Stream',
  'clientInfo.noLiveUrl': 'Không có Live Stream',
  'clientInfo.indexBannerImage': 'Banner trang chủ',
  'clientInfo.discountBannerImage': 'Banner giảm giá',
  'clientInfo.thirdPartyLoginAd': 'Quảng cáo trang đăng nhập bên thứ ba lần đầu',
  'clientInfo.kioskBannerImage': 'Banner ki-ốt',
  'clientInfo.checkinActivityBannerImage': 'Banner HĐ Điểm danh & Tích cực',
  'clientInfo.treasureBoxActivityBannerImage': 'Banner Hoạt động Rương báu',
  'clientInfo.loginBannerImage': 'Banner trang đăng nhập',
  'clientInfo.registerBannerImage': 'Banner trang đăng ký',
  'clientInfo.startupBannerImage': 'Banner trang khởi động',
  'clientInfo.language': 'Ngôn ngữ',
  'clientInfo.selectLanguage': 'Vui lòng chọn ngôn ngữ',
  'clientInfo.enterMenuOrder': 'Vui lòng nhập thứ tự menu',
  'clientInfo.enterMenuLink': 'Vui lòng nhập liên kết menu',
  'clientInfo.redirectLink': 'Liên kết/Code chuyển hướng',
  'clientInfo.enterRedirectLink': 'Vui lòng nhập liên kết/code chuyển hướng',
  'clientInfo.uploadImage': 'Vui lòng tải lên hình ảnh',
  'clientInfo.pc': 'PC',
  'clientInfo.h5': 'H5',
  'clientInfo.app': 'APP',
  'clientInfo.kiosk': 'Ki-ốt',
  'clientInfo.topImage': 'Hình ảnh trên cùng',
  'clientInfo.discountEntranceImage': 'Hình ảnh lối vào giảm giá',
  'clientInfo.logoImage': 'Hình ảnh logo',
  'clientInfo.pendantImage': 'Ảnh treo',
  'clientInfo.imageName': 'Tên hình ảnh',
  'clientInfo.enterImageName': 'Vui lòng nhập tên hình ảnh',
  'clientInfo.popupType': 'Loại popup trang chủ',
  'clientInfo.selectPopupType': 'Vui lòng chọn loại popup',
  'clientInfo.loginBefore': 'Trước khi đăng nhập',
  'clientInfo.loginAfter': 'Sau khi đăng nhập',
  'clientInfo.registerSuccess': 'Đăng ký thành công',
  'clientInfo.firstDepositDetainment': 'Giữ chân nạp lần đầu',
  'clientInfo.addSuccess': 'Thêm thành công',
  'clientInfo.addFailed': 'Thêm thất bại',
  'clientInfo.editSuccess': 'Chỉnh sửa thành công',
  'clientInfo.editFailed': 'Chỉnh sửa thất bại',
  'clientInfo.missingRedirectLink': 'Chưa nhập liên kết/code chuyển hướng',
  'clientInfo.pcImageUpload': 'Tải lên hình ảnh PC',
  'clientInfo.h5ImageUpload': 'Tải lên hình ảnh H5',
  'clientInfo.appImageUpload': 'Tải lên hình ảnh APP',
  'clientInfo.kioskImageUpload': 'Tải lên hình ảnh ki-ốt',
  'clientInfo.formValidationFailed': 'Xác thực biểu mẫu thất bại',
  'clientInfo.pcImage': 'Hình ảnh PC',
  'clientInfo.h5Image': 'Hình ảnh H5',
  'clientInfo.appImage': 'Hình ảnh APP',
  'clientInfo.kioskImage': 'Hình ảnh ki-ốt',
  'clientInfo.noImage': 'Không có hình ảnh',
  'clientInfo.dataLoadFailed': 'Tải dữ liệu thất bại',
  'clientInfo.activityHomeImage': 'Trang chủ hoạt động',
  'clientInfo.contactMethod': 'Phương thức liên hệ',
  'clientInfo.enterContactMethod': 'Vui lòng nhập phương thức liên hệ',
  'clientInfo.enterSort': 'Vui lòng nhập thứ tự',
  'clientInfo.redirectLinkCode': 'Liên kết/Code chuyển hướng',
  'clientInfo.enterRedirectLinkCode': 'Vui lòng nhập liên kết/code chuyển hướng',
  'clientInfo.iconUpload': 'Tải lên biểu tượng',
  'clientInfo.refreshMenuCache': 'Làm mới bộ nhớ cache menu',
  'clientInfo.menuName': 'Tên menu',
  'clientInfo.enterMenuName': 'Vui lòng nhập tên menu',
  'clientInfo.menuIcon': 'Biểu tượng menu',
  'clientInfo.navName': 'Tên điều hướng',
  'clientInfo.enterNavName': 'Vui lòng nhập tên điều hướng',
  'indexLtMenu.menuIcon': 'Biểu tượng menu',
  'indexBotMenu.menuName': 'Tên menu',
  'indexBotMenu.enterMenuName': 'Vui lòng nhập tên điều hướng',
  'indexBotMenu.menuIcon': 'Biểu tượng menu',
  'indexBotMenu.menuOrder': 'Thứ tự menu',
  'indexBotMenu.menuLink': 'Liên kết menu',
  'indexBotMenu.h5Icon': 'Biểu tượng H5',
  'indexBotMenu.pcIcon': 'Biểu tượng PC',
  'indexBotMenu.isEnable': 'Kích hoạt',
  'indexBotMenu.isMain': 'Menu chính',
  'clientInfo.imageTitle': 'Tiêu đề hình ảnh',
  'clientInfo.enterImageTitle': 'Vui lòng nhập tiêu đề hình ảnh',
  'clientInfo.status': 'Trạng thái',
  'clientInfo.selectStatus': 'Vui lòng chọn trạng thái'
}
